import { ODSModal, ODSButton, ODSGroup } from 'bc-ods';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useState, type ReactElement } from 'react';
// import useTextCopy from 'clipboard/useTextCopy';

type PropsType = {
  toggle: () => void;
  isOpen: boolean;
};

const messages = defineMessages({
  header: {
    id: 'ContactUs.header',
    defaultMessage: 'Contact us',
  },
  message: {
    id: 'ContactUs.message',
    defaultMessage: 'For Onebrief support, contact us at: {link}',
  },
  email: {
    id: 'ContactUs.email',
    defaultMessage: 'support@onebrief.com',
  },
  close: {
    id: 'ContactUs.close',
    defaultMessage: 'Dismiss',
  },
  tooltip: {
    id: 'ContactUs.tooltip',
    defaultMessage: '{isCopied, select, true {Copied!} other {Copy to clipboard}}',
  },
});

function ContactUs({ toggle, isOpen }: PropsType): ReactElement {
  const intl = useIntl();
  // const copy = useTextCopy();
  const [isCopied, setCopied] = useState(false);

  const email = intl.formatMessage(messages.email);
  const link = (
    <ODSGroup verticalAlign="center" inline spacing="sm">
      <a href={`mailto:${email}`} className="text-decoration-underline">
        <FormattedMessage {...messages.email} />
      </a>
      <ODSButton
        quiet
        icon="copy"
        onClick={() => {
          // This pulls in Maps, so we're not gonna do this right now.
          // copy(email);
          navigator.clipboard.writeText(email);
          setCopied(true);
          setTimeout(() => {
            setCopied(false);
          }, 1000);
        }}
        tooltip={intl.formatMessage(messages.tooltip, { isCopied })}
      />
    </ODSGroup>
  );

  return (
    <ODSModal
      isOpen={isOpen}
      toggle={toggle}
      title={<FormattedMessage {...messages.header} />}
      primary={<FormattedMessage {...messages.close} />}
    >
      <FormattedMessage
        {...messages.message}
        values={{
          link,
        }}
      />
    </ODSModal>
  );
}

export default ContactUs;
